export default __webpack_public_path__ + "static/media/vission.7643582e.svg";